import { render, staticRenderFns } from "./RecentOrdersTable.vue?vue&type=template&id=3bb6f8c5&scoped=true&"
import script from "./RecentOrdersTable.vue?vue&type=script&lang=js&"
export * from "./RecentOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/table.css?vue&type=style&index=0&id=3bb6f8c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6f8c5",
  null
  
)

export default component.exports